import React from "react";
import { useSelector } from "react-redux";
import { stackedBarPairedPalette } from "../colors";
import D3StackedBar from "./D3StackedBar";
import RccCard from "../RccCard";
import { useWonAcvVerticalData } from "../hooks/useWonAcvData";

/**
 * WonACVByVerticalCard.jsx
 *
 * Thin wrapper card that renders Won ACV mix by Vertical.
 * Uses the shared won ACV hook to fetch, transform, and supply chart data.
 *
 */
function WonACVByVerticalCard({ title, redirectToDashboard }) {
  const user = useSelector((state) => state.app.user || {});
  const Value_Label = useSelector((state) => state.app.user.Value_Label);
  const { chartData, derivedCategories, appliedFilters, isLoading } =
    useWonAcvVerticalData();

  const handleZoom = () => {
    console.log("Zooming card...");
  };

  return (
    <RccCard
      title={title || `Won ${Value_Label} by Vertical`}
      isLoading={isLoading}
      redirectToDashboard={
        redirectToDashboard || `Won ${Value_Label} Mix Analysis`
      }
      onZoomClick={handleZoom}
      appliedFilters={appliedFilters}
      focusVariant={"current"}
    >
      <D3StackedBar
        data={chartData}
        categories={derivedCategories}
        colorPalette={stackedBarPairedPalette}
        currencySymbol={user?.Currency}
        options={{
          showLabels: true,
          showLegend: true,
        }}
      />
    </RccCard>
  );
}

export default WonACVByVerticalCard;
